import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import api from '../services/api';

const fmt = v => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(v||0);

// Muestra a cuál proveedor conviene comprarle cada producto que ambos venden.
// Solo aparecen los que se pudieron confirmar como el mismo producto (mismo tipo, marca,
// capacidad y referencia); comparar por parecido de nombre daba resultados falsos.
export default function CompararProveedores() {
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const [lado, setLado] = useState('b');       // 'b' = conviene Metro, 'a' = conviene Tecnoplaza
  const [minimo, setMinimo] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get('/api/catalogo/comparar-proveedores?a=Tecnoplaza&b=Metro');
        setDatos(r.data);
      } catch (e) { setError(e.response?.data?.error || e.message); }
      setCargando(false);
    })();
  }, []);

  if (cargando) return <Layout><div style={{ padding:'26px', color:'rgba(255,255,255,0.4)' }}>Comparando los dos catálogos…</div></Layout>;
  if (error) return <Layout><div style={{ padding:'26px', color:'#FCA5A5' }}>No se pudo comparar: {error}</div></Layout>;

  const { proveedorA, proveedorB, resumen, pares } = datos;
  const lista = pares
    .filter(p => (lado === 'b' ? p.diferencia > 0 : p.diferencia < 0))
    .filter(p => Math.abs(p.diferencia) >= minimo);
  const ganador = lado === 'b' ? proveedorB : proveedorA;
  const perdedor = lado === 'b' ? proveedorA : proveedorB;

  return (
    <Layout>
      <div style={{ padding:'22px 26px' }}>
        <h1 style={{ fontSize:'20px', fontWeight:'700', color:'#fff', marginBottom:'4px' }}>
          ⚖️ Comparar proveedores
        </h1>
        <p style={{ fontSize:'13px', color:'rgba(255,255,255,0.45)', marginBottom:'16px', maxWidth:'780px', lineHeight:'1.55' }}>
          Productos que venden los dos proveedores, con el costo de cada uno. Se compara
          contra el costo real de la lista de precios, no contra el precio de venta.
          Se muestran <b style={{color:'rgba(255,255,255,0.7)'}}>solo los que se pudieron confirmar como el mismo producto</b> —
          misma marca, misma referencia y misma capacidad.
        </p>

        <div style={{ display:'flex', gap:'12px', marginBottom:'18px', flexWrap:'wrap' }}>
          {[
            { l:'Productos comparables', v:resumen.comparables, sub:`de ${datos.totalA} y ${datos.totalB}`, c:'#fff' },
            { l:`Más barato en ${proveedorB}`, v:resumen.mejor_en_b, sub:fmt(resumen.ahorro_en_b)+' en total', c:'#EC4899' },
            { l:`Más barato en ${proveedorA}`, v:resumen.mejor_en_a, sub:fmt(resumen.ahorro_en_a)+' en total', c:'#3B82F6' },
          ].map(x => (
            <div key={x.l} style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'11px', padding:'13px 18px', minWidth:'170px' }}>
              <div style={{ fontSize:'11px', color:'rgba(255,255,255,0.4)', marginBottom:'3px' }}>{x.l}</div>
              <div style={{ fontSize:'19px', fontWeight:'700', color:x.c }}>{x.v}</div>
              <div style={{ fontSize:'11px', color:'rgba(255,255,255,0.3)' }}>{x.sub}</div>
            </div>
          ))}
        </div>

        <div style={{ display:'flex', gap:'8px', marginBottom:'14px', flexWrap:'wrap', alignItems:'center' }}>
          {[['b', `Conviene ${proveedorB}`], ['a', `Conviene ${proveedorA}`]].map(([k, t]) => (
            <button key={k} onClick={()=>setLado(k)} style={{
              padding:'7px 14px', borderRadius:'8px', fontSize:'12.5px', cursor:'pointer',
              border: lado===k ? '1px solid rgba(99,102,241,0.5)' : '1px solid rgba(255,255,255,0.1)',
              background: lado===k ? 'rgba(99,102,241,0.15)' : 'rgba(255,255,255,0.03)',
              color: lado===k ? '#A5B4FC' : 'rgba(255,255,255,0.55)', fontWeight: lado===k?'600':'400',
            }}>{t}</button>
          ))}
          <span style={{ marginLeft:'8px', fontSize:'12px', color:'rgba(255,255,255,0.4)' }}>Diferencia mínima:</span>
          <select value={minimo} onChange={e=>setMinimo(Number(e.target.value))}
            style={{ padding:'6px 10px', borderRadius:'7px', background:'rgba(255,255,255,0.05)',
                     border:'1px solid rgba(255,255,255,0.12)', color:'#fff', fontSize:'12.5px' }}>
            <option value={0}>Todas</option>
            <option value={20000}>$20.000</option>
            <option value={50000}>$50.000</option>
            <option value={100000}>$100.000</option>
          </select>
        </div>

        <div style={{ display:'grid', gap:'8px' }}>
          {lista.length === 0 && (
            <div style={{ color:'rgba(255,255,255,0.35)', padding:'26px', textAlign:'center', background:'rgba(255,255,255,0.02)', borderRadius:'10px' }}>
              No hay productos en esta lista con ese filtro.
            </div>
          )}
          {lista.map(p => {
            const dif = Math.abs(p.diferencia);
            const base = lado === 'b' ? p.a.costo : p.b.costo;
            const pct = base ? Math.round(dif / base * 100) : 0;
            return (
              <div key={p.a.id} style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:'10px', padding:'13px 15px' }}>
                <div style={{ display:'flex', justifyContent:'space-between', gap:'14px', flexWrap:'wrap' }}>
                  <div style={{ flex:'1 1 340px', minWidth:0 }}>
                    <div style={{ fontSize:'13px', color:'#fff', fontWeight:'600', marginBottom:'6px' }}>{p.a.nombre}</div>
                    <div style={{ fontSize:'11.5px', color:'rgba(255,255,255,0.35)', lineHeight:'1.5' }}>
                      En {proveedorB}: {p.b.nombre}
                    </div>
                  </div>
                  <div style={{ display:'flex', gap:'16px', alignItems:'center', flexShrink:0 }}>
                    <div style={{ textAlign:'right', fontSize:'12px' }}>
                      <div style={{ color: lado==='a' ? '#4ADE80' : 'rgba(255,255,255,0.45)', fontWeight: lado==='a'?'700':'400' }}>
                        {proveedorA} {fmt(p.a.costo)}
                      </div>
                      <div style={{ color: lado==='b' ? '#4ADE80' : 'rgba(255,255,255,0.45)', fontWeight: lado==='b'?'700':'400' }}>
                        {proveedorB} {fmt(p.b.costo)}
                      </div>
                      {p.a.costo_estimado && (
                        <div style={{ color:'#FBBF24', fontSize:'10.5px', marginTop:'2px' }}>
                          ⚠ {proveedorA} sin costo del PDF (precio web)
                        </div>
                      )}
                    </div>
                    <div style={{ textAlign:'right', minWidth:'92px' }}>
                      <div style={{ fontSize:'15px', fontWeight:'700', color: lado==='b' ? '#EC4899' : '#3B82F6' }}>{fmt(dif)}</div>
                      <div style={{ fontSize:'11px', color:'rgba(255,255,255,0.35)' }}>{pct}% menos</div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div style={{ marginTop:'18px', background:'rgba(251,191,36,0.07)', border:'1px solid rgba(251,191,36,0.22)', borderRadius:'9px', padding:'12px 15px', fontSize:'12.5px', color:'#FDE047', lineHeight:'1.55' }}>
          Antes de comprar, confirma que sea de verdad el mismo producto: dos equipos pueden
          llamarse igual y traer distinta memoria o distinto disco. Aquí se comparan nombres,
          no fichas técnicas.
        </div>
      </div>
    </Layout>
  );
}
